import { Inject, Injectable } from '@angular/core';
import { MSAL_INSTANCE } from '@azure/msal-angular';
import { AccountInfo, PublicClientApplication } from '@azure/msal-browser';
import { filterUndefined } from 'src/app/lego-utils';
import * as Sentry from '@sentry/angular';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  private readonly accountActive = new BehaviorSubject<boolean>(false);
  public readonly accountActive$ = this.accountActive.asObservable();

  public constructor(
    @Inject(MSAL_INSTANCE) private readonly msalInstance: PublicClientApplication
  ) {}

  public setActiveAccount(): AccountInfo | undefined {
    const accounts = this.msalInstance.getAllAccounts();

    if (accounts.length > 0) {
      const account = accounts[0];

      this.msalInstance.setActiveAccount(account);
      this.accountActive.next(true);

      Sentry.setUser({
        id: account.localAccountId,
        username: account.name,
        email: account.username,
        ip_address: '{{auto}}',
      });

      return account;
    }

    return undefined;
  }

  public getActiveAccount(): Observable<AccountInfo> {
    return this.accountActive.pipe(
      filter((x) => x),
      map(() => this.msalInstance.getActiveAccount()),
      filterUndefined()
    );
  }
}
